"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityProgrammeSet = void 0;
const uuid_1 = require("uuid");
const ProgrammeTypes_1 = require("../../../types/ProgrammeTypes");
const lambda_1 = require("../../../util/lambda");
const ModelCommon_1 = require("../../ModelCommon");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
class EntityProgrammeSet extends ModelCommon_1.ModelCommon {
    constructor({ id = (0, uuid_1.v4)(), supportedType, maxProgrammes, name, appliedTimestampsMs, enabled, ...others }) {
        super('EntityProgrammeSet', { id, ...others });
        this.maxAppliedTimestamps = 50;
        this.updateAppliedTimestamps = (timestampMs) => {
            if (!this.appliedTimestampsMs) {
                this.appliedTimestampsMs = [];
            }
            this.appliedTimestampsMs?.unshift(timestampMs);
            this.appliedTimestampsMs = this.appliedTimestampsMs.slice(0, this.maxAppliedTimestamps);
        };
        this.maxProgrammes = maxProgrammes ?? 5;
        this.name = name;
        this.supportedType = supportedType;
        this.appliedTimestampsMs = appliedTimestampsMs ?? null;
        this.enabled = enabled ?? true;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            supportedType: {
                type: 'Enum',
                editable: true,
                required: true,
                enumKv: ProgrammeTypes_1.ProgrammeSupportedTypesEnum,
            },
            maxProgrammes: {
                type: 'Number',
                default: 5,
                editable: false,
                label: `Max Programmes`,
                precision: 0,
                required: true,
                description: 'the maximum number of programmes allowed with a set. For default IoTV Devices this is set to 5',
            },
        };
    }
}
exports.EntityProgrammeSet = EntityProgrammeSet;
